<template>
  <svg class="icon-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill-rule="nonzero" fill="none">
      <g :stroke="color" stroke-width="1">
        <path d="M12.77 16.546l-4.665-1.548v1.841l4.665 2.378v-2.67z"/>
        <path
            d="M6.396 7.994l9.955-3.75a.48.48 0 0 1 .649.45V17.44a.48.48 0 0 1-.648.45L6.37 14.148a3.29 3.29 0 0 1-1.09.184A3.274 3.274 0 0 1 2 11.067 3.274 3.274 0 0 1 5.281 7.8c.392 0 .767.068 1.115.194z"/>
      </g>
      <path d="M19 7.898L22.248 6M19 15l3.127 1.434M19 11.25h3.5" :stroke="color" stroke-linecap="round"/>
      <rect :fill="color" x="6" y="8" width="1" height="4" rx=".5"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "IconNotify",
    props: {
      color: {
        default: '#373737',
      },
    },
  }
</script>

<style scoped lang="scss">

  .icon-notify {
    width: 0.24rem;
    height: 0.24rem;
  }


</style>